import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
// AppContext creation with initial undefined value
const AppContext = createContext(undefined);
// Custom hook to use the AppContext
export function useAppContext() {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useAppContext must be used within an AppProvider");
    }
    return context;
}
// AppProvider component definition
export function AppProvider({ children }) {
    const [user, setUser] = useState(null);
    const appStore = {
        user,
        setUser,
    };
    return _jsx(AppContext.Provider, { value: appStore, children: children });
}
// Export the context for use in other components
export default AppContext;
